import { useState } from "react";
import { useDashboard } from "../api/admin/dashboard";
import DashboardAlertsSection from "../components/DashboardAlerts/DashboardAlertsSection";
import DashboardDriverRiskCategories from "../components/Dashboard/DashboardDriverRiskCategories";
import DashboardReports from "../components/Dashboard/DashboardReports";
import PageLayout from "../components/PageLayout";
import { useCompanyDepartmentSelector } from "../components/ReusableComponents/CompanyDepartmentSelector";
import HeaderOptions, {
    TailoredButton,
} from "../components/ReusableComponents/HeaderOptions";
import { useNavigate } from "react-router-dom";
import { appPaths } from "../Routes";
import {
    DashboardCategories,
    type DashboardCategoriesType,
} from "../models/api/admin/dashboard";
import { Plus } from "phosphor-react";

const DashboardPage: React.FC = () => {
    const [date, setDate] = useState(new Date());
    const [compareMonths, setCompareMonths] = useState<number>();
    const [selectedTab, setSelectedTab] = useState<DashboardCategoriesType>(
        DashboardCategories.Drivers
    );

    const employmentFilters = useCompanyDepartmentSelector();
    const { selectedCompany, selectedDepartment } = employmentFilters;

    // split into two requests as risk categories take a long time to calculate
    const {
        dashboardData: riskProfileData,
        isLoadingDashboard: isLoadingRiskProfiles,
    } = useDashboard(
        {
            companyId: selectedCompany?.companyId ?? undefined,
            departmentId: selectedDepartment?.departmentId ?? undefined,
            date: date.toISOString(),
            compareMonths,
        },
        DashboardCategories.RiskProfiles
    );

    const { dashboardData, isLoadingDashboard } = useDashboard(
        {
            companyId: selectedCompany?.companyId ?? undefined,
            departmentId: selectedDepartment?.departmentId ?? undefined,
            date: date.toISOString(),
            compareMonths,
        },
        selectedTab
    );

    const navigate = useNavigate();

    const headerButtons: TailoredButton[] = [
        {
            title: `Add driver`,
            onClick: () => navigate(appPaths.adminAddDriver),
            icon: Plus,
        },
    ];

    return (
        <PageLayout header={false} title="Dashboard">
            <div className="flex flex-col gap-6">
                <HeaderOptions
                    employmentFilters={employmentFilters}
                    tailoredButtons={headerButtons}
                />
                <DashboardDriverRiskCategories
                    dashboardData={riskProfileData}
                    isLoading={isLoadingRiskProfiles}
                    selectedCompany={selectedCompany?.companyId}
                    selectedDepartment={selectedDepartment?.departmentId}
                />
                <DashboardAlertsSection
                    alertsData={dashboardData?.alerts}
                    isLoadingAlerts={isLoadingDashboard}
                    selectedTab={selectedTab}
                    setSelectedTab={setSelectedTab}
                    selectedCompany={selectedCompany}
                    selectedDepartment={selectedDepartment}
                />
                <DashboardReports
                    date={date}
                    compareMonths={compareMonths}
                    data={dashboardData}
                    loading={isLoadingDashboard}
                    onDateChange={setDate}
                    onCompareMonthsChange={setCompareMonths}
                    selectedTab={selectedTab}
                    companyId={selectedCompany?.companyId}
                    departmentId={selectedDepartment?.departmentId}
                />
            </div>
        </PageLayout>
    );
};

export default DashboardPage;
